import { render, staticRenderFns } from "./AppDownloadBanner.vue?vue&type=template&id=b5d5cc68"
import script from "./AppDownloadBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppDownloadBanner.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports